import { Header, Main } from '@pcrm/fe/ui-kit';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/clienti')({
  component: ClientiLayout,
});

/**
 * Cadrul zonei de clienți: listă, fișă și adăugare.
 *
 * `Header` și `Main` stau în layout, nu în fiecare pagină — aceeași abatere conștientă ca la
 * `/setari`, din același motiv: trei ecrane cu același antet, scris o dată. Antetul spune
 * doar „Clienți"; ce client anume se citește din cardul fișei, unde e și codul, și
 * denumirea oficială.
 */
function ClientiLayout() {
  return (
    <>
      <Header fixed>
        <h1 className="text-lg font-semibold">Clienți</h1>
      </Header>

      <Main className="flex flex-1 flex-col gap-4 sm:gap-6">
        <Outlet />
      </Main>
    </>
  );
}
